module.exports = {"id":"169432","name":"Mehdi Lacen","rating":"72","photo":"./data/images/photos/3/169432.png","club":{"name":"Málaga CF","logo":"./data/images/clubs/MalagaCF.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MehdiLacen0.json
// module id = 2966
// module chunks = 0